import React from 'react'

import moment from 'moment'
import { AwaitingShippingIcon } from './components/TrackingIconStatus/awaiting-shipping-icon'
import { PaymentConfirmedIcon } from './components/TrackingIconStatus/payment-confirmed-icon'
import { OrderPlacedIcon } from './components/TrackingIconStatus/order-placed-icon'
import { PreparationOrderIcon } from './components/TrackingIconStatus/preparation-order-icon copy'
import { OrderDeliveredIcon } from './components/TrackingIconStatus/order-delivered-icon'
import { CanceledOrderIcon } from './components/TrackingIconStatus/canceled-order-icon'
import { DeliveredShippingIcon } from './components/TrackingIconStatus/delivered-shipping-icon'
import { AwaitingPaymentIcon } from './components/TrackingIconStatus/awaiting-payment-icon'
import { buildTrackingSteps } from '@shared/trackingSteps'


// ícones por status — a LÓGICA dos passos foi extraída para shared/trackingSteps.js
// (compartilhada com a área da conta V2), sem mudança de comportamento
const STATUS_ICONS = {
  NEW: OrderPlacedIcon,
  PW: AwaitingPaymentIcon,
  AP: PaymentConfirmedIcon,
  PP: PreparationOrderIcon,
  PF: AwaitingShippingIcon,
  PT: DeliveredShippingIcon,
  PE: OrderDeliveredIcon,
  C: CanceledOrderIcon,
}

const TrackingTimeline = ({ subOrder, order }) => {

  const filteredStatusList = buildTrackingSteps(subOrder, order).map(step => ({
    ...step,
    icon: STATUS_ICONS[step.status],
  }))

  return (
    <div className="tracking-timeline">
      <ul className={'tracking-timeline__steps'}>
        {filteredStatusList.map((status, index) => {
          return !status.hidden && <TrackingStep
            key={index}
            status={status}
          />
        })}
      </ul>
    </div>
  )
}

const TrackingStep = ({ status }) => {

  const Icon = status.icon;

  return (
    <li className={`tracking-timeline__step ${status.disabled && 'disabled-step'}`}>
      <div className="tracking-timeline__step-details">
        <div className="circle">
          {status.disabled ? <Icon active={'#ddd'} /> : <Icon active={status.color} />}
        </div>
        <div className="tracking-timeline__step-info">
          <p className={`status ${status.disabled && 'text-disabled'}`}>{status.label}</p>
          {!status.disabled && status.changed ? (
            <p className="date">
              {moment(status.changed).format('DD/MM/YYYY')}
            </p>
          ) : null}
        </div>
      </div>
    </li>
  )
}

export default TrackingTimeline

